import { render, staticRenderFns } from "./standard-map.vue?vue&type=template&id=7312f09b"
import script from "./standard-map.vue?vue&type=script&lang=js"
export * from "./standard-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports